module.exports = __webpack_public_path__ + "img/payment_paypal.b015ac72.png";